import React, { useEffect, useRef, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, convertToRaw, EditorState, Modifier } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';

const MyEditor = ({ memberList, setEditorContent, setMentionIds, defaultMention }) => {
	let initialEditorState;
	if (defaultMention) {
		const contentBlock = htmlToDraft(defaultMention);
		if (contentBlock) {
			const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			initialEditorState = EditorState.createWithContent(contentState);
		} else {
			initialEditorState = EditorState.createEmpty();
		}
	} else {
		initialEditorState = EditorState.createEmpty();
	}
	const [editorState, setEditorState] = useState(initialEditorState);
	const [suggestions, setSuggestions] = useState([]);
	const editorRef = useRef(null);

	useEffect(() => {
		if (editorRef.current) {
			editorRef.current.focusEditor();
		}
	}, []);

	useEffect(() => {
		if (memberList) {
			let tmpData = memberList.map((item) => ({
				text: item.value,
				value: item.value,
				url: item.memberId
			}));
			setSuggestions(tmpData);
		}
	}, [memberList]);

	const onEditorStateChange = (editorState) => {
		setEditorState(editorState);
	};

	useEffect(() => {
		const content = convertToRaw(editorState.getCurrentContent());
		setEditorContent(draftToHtml(content));
		let ids = [];
		if (content?.entityMap) {
			for (let key in content.entityMap) {
				if (content.entityMap[key].type === 'MENTION') {
					ids.push(content.entityMap[key].data.url);
				}
			}
		}
		setMentionIds(ids);
	}, [editorState]);

	const handleContentStateChange = (contentState) => {
		let str = contentState.blocks[0].text;
		const lastChar = str.charAt(str.length - 1);
		if (lastChar === '@') {
			const scrollContainer = document.querySelector('.rdw-suggestion-dropdown');
			let scrollIncrement = 20;
			document.addEventListener('keydown', (event) => {
				if (event.key === 'ArrowDown' && scrollContainer) {
					scrollContainer.scrollBy({
						top: scrollIncrement,
						behavior: 'smooth'
					});

					scrollIncrement += 2;
				} else if (event.key === 'ArrowUp' && scrollContainer) {
					scrollContainer.scrollBy({
						top: -scrollIncrement,
						behavior: 'smooth'
					});

					scrollIncrement += 2;
				}
			});
		}
	};

	return (
		<Editor
			handlePastedText={(text, html, editorState) => {
				if (text) {
					const contentState = editorState.getCurrentContent();
					const selectionState = editorState.getSelection();

					// Insert the pasted text at the current cursor position
					const newContentState = Modifier.insertText(contentState, selectionState, text);

					const newEditorState = EditorState.push(
						editorState,
						newContentState,
						'insert-characters'
					);

					setEditorState(newEditorState);
					return true; // Prevent default paste behavior
				}
				return false;
			}}
			ref={editorRef}
			onContentStateChange={handleContentStateChange}
			toolbarHidden={true}
			editorState={editorState}
			onEditorStateChange={onEditorStateChange}
			toolbarClassName="editor-toolbar"
			wrapperClassName="editor-wrapper"
			editorClassName="editor-content"
			mention={{
				separator: ' ',
				trigger: '@',
				suggestions: suggestions
			}}
		/>
	);
};

export default MyEditor;
